
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"21","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.938 14.542v.833a2.5 2.5 0 01-2.5 2.5v0a2.5 2.5 0 01-2.5-2.5v-.833m5 0s.28-.935.833-2.5c.484-1.373 1.666-1.406 1.666-4.167a5 5 0 00-10 0c0 2.761 1.183 2.794 1.667 4.167.552 1.565.833 2.5.833 2.5m5 0h-2.5m-2.5 0h2.5m0 0v-3.334","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    